import React from "react";
import "./textInput.css";
import PropTypes from "prop-types";

const TextInput = ({
  placeholder,
  value,
  type,
  onChange,
  maxLength,
  onKeyDown,
  disabled,
  onInput,
}) => {
  return (
    <div>
      <input
        className="new-input"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        type={type}
        onChange={onChange}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        onInput={onInput}
      ></input>
    </div>
  );
};
TextInput.propTypes = {
  value: PropTypes.string,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  onKeyDown: PropTypes.func,
  onInput: PropTypes.func,
  disabled: PropTypes.boolean,
};
export default TextInput;
